import Vue from 'vue';

// Lightweight cross-component event bus. Used so the BottomDock's "Pay" plate
// can trigger the cart's own handlePayment() (which keeps all its validation)
// without duplicating the payment logic.
export const EventBus = new Vue();

export default EventBus;
